import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { K, inputStyle } from '../constants';
import { Btn } from '../components/ui';
import { useToast } from '../components/Toast';

const SUPPORT_EMAIL = 'dev@cubbyco.net';

const CATEGORIES = [
  { id: 'suggestion', label: 'Suggestion', col: K.info },
  { id: 'bug',        label: 'Bug Report',  col: K.bad },
  { id: 'question',   label: 'Question',    col: K.ems },
  { id: 'other',      label: 'Other',       col: K.t2 },
];

export function FeedbackModal({ onClose, user }) {
  const [category, setCategory] = useState('suggestion');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const toast = useToast();

  const submit = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      await addDoc(collection(db, 'feedback'), {
        category,
        message: message.trim(),
        uid: user?.uid || null,
        email: user?.email || 'guest',
        createdAt: serverTimestamp(),
        status: 'new',
      });
      setSent(true);
    } catch (e) {
      toast('Failed to submit feedback', 'error');
    }
    setSending(false);
  };

  const activeCat = CATEGORIES.find((c) => c.id === category);

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 400, background: '#000000cc' }} />

      <div className="hc-modal-sheet" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 401, background: K.bg1, borderRadius: '16px 16px 0 0', padding: 24, maxWidth: 480, margin: '0 auto' }}>
        <div style={{ width: 40, height: 4, background: K.bdr2, borderRadius: 2, margin: '0 auto 20px' }} />

        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0 10px' }}>
            <div style={{ fontFamily: K.fSans, fontSize: 14, fontWeight: 600, color: K.ok, marginBottom: 12, letterSpacing: 0.4 }}>Submitted</div>
            <div style={{ fontFamily: K.fSans, fontSize: 22, fontWeight: 700, color: K.t0, marginBottom: 6 }}>Thanks!</div>
            <div style={{ fontSize: 12, color: K.t2, lineHeight: 1.6, marginBottom: 20 }}>
              Your feedback has been submitted. We appreciate you helping improve HydroCalc.
            </div>
            <Btn onClick={onClose} col={K.info} block>Done</Btn>
          </div>
        ) : (
          <>
            <div style={{ fontFamily: K.fSans, fontSize: 22, fontWeight: 700, color: K.t0, marginBottom: 4 }}>
              Feedback & Support
            </div>
            <div style={{ fontSize: 11, color: K.t3, marginBottom: 18, lineHeight: 1.5 }}>
              Have a suggestion, found a bug, or need help? Let us know below or email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: K.info, textDecoration: 'none' }}>{SUPPORT_EMAIL}</a>
            </div>

            {/* Category picker */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 16 }}>
              {CATEGORIES.map((c) => (
                <button
                  key={c.id}
                  className="hc-btn"
                  onClick={() => setCategory(c.id)}
                  style={{
                    background: category === c.id ? `${c.col}22` : K.bg2,
                    border: `1px solid ${category === c.id ? c.col : K.bdr}`,
                    color: category === c.id ? c.col : K.t2,
                    padding: '10px 8px',
                    borderRadius: 8,
                    cursor: 'pointer',
                    fontFamily: K.fSans,
                    fontSize: 14,
                    fontWeight: 600,
                    letterSpacing: 0.4,
                  }}
                >
                  {c.label}
                </button>
              ))}
            </div>

            {/* Message */}
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={
                category === 'suggestion' ? 'Describe your idea or feature request...' :
                category === 'bug' ? 'What happened? What did you expect to happen?' :
                category === 'question' ? 'What do you need help with?' :
                'What\'s on your mind?'
              }
              rows={4}
              style={{
                ...inputStyle(),
                width: '100%',
                resize: 'vertical',
                minHeight: 100,
                fontFamily: K.fSans,
                fontSize: 13,
                lineHeight: 1.6,
                marginBottom: 6,
              }}
            />

            <div style={{ fontSize: 10, color: K.t3, marginBottom: 14, textAlign: 'right' }}>
              {user ? `Sending as ${user.email}` : 'Sending as guest'}
            </div>

            <Btn
              onClick={submit}
              col={activeCat?.col || K.info}
              block
              disabled={!message.trim() || sending}
            >
              {sending ? 'Sending...' : 'Submit Feedback'}
            </Btn>

            <button
              onClick={onClose}
              style={{
                width: '100%', marginTop: 10, background: 'none', border: 'none',
                color: K.t3, cursor: 'pointer', fontSize: 11,
                fontFamily: K.fSans, padding: '8px',
              }}
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </>
  );
}
